import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

import { aiAgentColors } from 'constants/aiAgentColors';

import { Button } from '../../../../components/Button';

export const StyledEmptyIcon = styled.div`
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 160px;
    height: 96px;
    object-fit: contain;
  }
`;

export const StyledEmptyText = styled.div`
  ${setFontVariant('body2', colorsPalettes.carbon[300])};
  text-align: center;
  line-height: 20px;
  margin-bottom: 20px;
  max-width: 50%;
`;

export const StyledGenerateButton = styled(Button)`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 10px 28px;
  border-radius: 32px;
  background: linear-gradient(90deg, ${aiAgentColors.gradient.blue} 1%, ${aiAgentColors.gradient.green} 100%);
  ${setFontVariant('button', colorsPalettes.carbon[0])};
  line-height: 20px;

  &:hover,
  &:active {
    background: linear-gradient(90deg, #5c8ee6 1%, #3cc7a5 100%);
  }

  &:active {
    background: linear-gradient(90deg, #4a7ad0 1%, #2eac8a 100%);
  }

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`;
